<template>
    <section>
        <start-membership />
        <div class="row">
            <div
                v-for="(theme, index) in limitedThemes"
                :key="theme.id"
                class="col-12 col-md text-truncate"
                @click="onThemeClicked(index)"
            >
                <theme-box :number="index + 1" :title="theme.title" />
            </div>
        </div>
    </section>
</template>
<script>

import { mapGetters } from "vuex";

export default {
    name: "BookinsightTheme",
    components: {
        themeBox: () => import(/* webpackChunkName: "theme-box"*/ "./theme-box"),
        startMembership: () => import(/* webpackChunkName: "start-membership"*/ "@c/books-insights/modals/start-membership")
    },
    props: {
        themes: {
            type: Array,
            required: true
        },
        isPremium: {
            type: Boolean,
            default: false
        },
        isFreemium: {
            type: Boolean,
            defualt: false
        }
    },
    data() {
        return {
            maxThemes: 3
        }
    },
    computed: {
        limitedThemes() {
            return this.themes.slice(0, this.maxThemes);
        },
        ...mapGetters({
            isLoggedIn: "User/isLoggedIn"
        })
    },
    methods: {
        onThemeClicked(index) {
            if (index >= 1 && this.freemiumBiLocked()) {
                this.$modal.show("start-membership");
                return;
            }
            this.$emit("open-reader", index);
        },
        freemiumBiLocked() {
            return this.isFreemium && !this.isLoggedIn;
        }
    }
}
</script>
<style>

</style>
